<template>
  <div class="course-warp" id="stayModuleSelection">
    <div class="course-menu-warp">
      <div class="course-menu">
        <div class="menu-line grade-line">
          <span class="menu-title">年级</span>
          <span
            v-for="(itemList, key) in gradeList"
            :key="key"
            class="grade-list"
          >
            <span
              :class="
                item.value == gradeSelect ? 'grade-item-select' : 'grade-item'
              "
              v-for="(item, index) in itemList"
              :key="index"
              @click="changeGrade(item.value)"
              >{{ item.label }}</span
            >
            <span class="border"></span>
          </span>
        </div>
        <div class="menu-line subject-line">
          <span class="menu-title">科目</span>
          <span
            :class="
              index == subjectSelect ? 'subject-item-select' : 'subject-item'
            "
            v-for="(item, index) in subjectList"
            :key="index"
            @click="changeSubject(index)"
            >{{ item }}</span
          >
        </div>
      </div>
    </div>
    <div class="course-content">
      <div v-for="(item, key) in 6" :key="key" class="course-item">
        <div class="item-course">{{key == 0 ? "爆品课" : "精选课"}}</div>
        <!-- <div class="course-item-content"> -->
          <p class="item-title"><span>{{ courseList.subjectname[subjectSelect] }}</span>
          【秋季】{{ courseList.subject[subjectSelect]
            }}{{ courseList.title[key] }}</p>
          <p class="item-subtitle">{{ courseList.subjectdes[subjectSelect][key]
            }}</p>
          <p class="item-des">适合学员：{{ courseList.subjectsubdes[subjectSelect]
            }}</p>
        <div class="item-bottom">
          <div class="img-warp">
            <img :src="img" alt="" v-for="(img,index) in teacherimg[subjectSelect][key]" :key="index">
          </div>
          <div class="item-appoint" @click="popupFormShow()">立即咨询</div>
        </div>
      </div>
    </div>
    <popupform :isPopupFormShow="isPopupFormShow" @popupFormClose="popupFormClose" :origin="origin" :subjectName="subjectList[subjectSelect]"></popupform>
  </div>
</template>

<script>
import popupform from "@/components/popupform";
import {teacherimg} from '@/const/list.js';
import {saTrack} from '@xes/dh-sensor';

export default {
  name: "course",
  components: {
    popupform,
  },
  data() {
    return {
      origin:"",
      teacherimg,
      gradeList: [
        [
          {
            value: "10",
            label: "四年级",
          },
          {
            value: "9",
            label: "五年级",
          },
          {
            value: "7",
            label: "六年级",
          },
        ],
        [
          {
            value: "1",
            label: "初一",
          },
          {
            value: "2",
            label: "初二",
          },
          {
            value: "3",
            label: "初三",
          },
        ],
        [
          {
            value: "4",
            label: "高一",
          },
          {
            value: "5",
            label: "高二",
          },
          {
            value: "6",
            label: "高三",
          },
        ],
      ],
      subjectList: ["数学", "语文", "英语", "物理", "化学"],
      subjectSelect: 0,
      gradeSelect: 10,
      courseList: {
        title: [
          "1对1模块突破课",
          "1对1综合特训课",
          "1对1期末冲刺课",
          "1对1拓展突破课",
          "1对1综合提升课",
          "1对1衔接复习课",
        ],
        subject: ["数学", "语文", "英语", "物理", "化学"],
        subjectname: ["数", "语", "英", "物", "化"],
        subjectdes: [
          //数学
          [
            "掌握运算法则 · 巧算特训 · 攻克计算难点",
            "常考性质精讲 · 典题剖析 · 吃透函数考点",
            "系统梳理 · 查缺补漏 · 专题练习 · 综合提升",
            "课内进阶 · 模块精讲 · 重点强化 · 专项突破",
            "知识拓展 · 难点攻克 · 综合训练 · 思维提升",
            "定位漏洞 · 专项特训 · 突破短板 · 综合提升",
          ],
          //语文
          [
            "高分结构点拨 · 专题集训 · 写作技法精讲",
            "阅读技巧精讲 · 综合题型详解 · 实战特训",
            "文言文基础巩固 · 诗词详解 · 知识拓展",
            "聚焦考点 · 同步课内 · 模块精讲 · 定向提升",
            "同步课内 · 夯实字词基础 · 阅读技巧精讲",
            "课内知识拓展 · 阅读能力提升 · 写作突破",
          ],
          //英语
          [
            "语法知识精讲 · 时态运用详解 · 真题实战",
            "高频考点剖析 · 完型特训 · 破除阅读障碍",
            "经典素材积累 · 结构点拨 · 写作技法精讲",
            "紧扣考纲 · 知识梳理 · 语法精讲 · 写作特训",
            "同步课内 · 夯实词法基础 · 阅读精讲",
            "课内知识拓展 · 阅读能力提升 · 写作突破",
          ],
          //物理
          [
            "攻克电学难点 · 答题思路点拨 · 技巧特训",
            "夯实力学基础 · 综合题型详解 · 真题巩固",
            "紧扣考纲 · 夯实基础概念 · 题型综合训练",
            "同步课内 · 全面梳理 · 夯实基础 · 查缺补漏",
            "课内进阶 · 模块精讲 · 重点强化 · 专项突破",
            "知识拓展 · 难点攻克 · 综合训练 · 思维提升",
          ],
          //化学
          [
            "公式梳理 · 必记概念强化 · 化学式计算特训",
            "常考原理精讲 ·实验模型巩固 · 解答技巧特训",
            "查缺补漏 · 夯实基础 · 突破短板 · 新知预学",
            "夯实基础 · 模块精讲 · 同步课内全面提升",
            "课内知识进阶 · 重点模块突破 · 能力提升",
            "知识拓展 · 攻克难点 · 实验探究 · 思维提升",
          ],
        ],
        subjectsubdes: [
          "四年级-高三年级 · 个性定制",
          "四年级-高三年级 · 个性定制",
          "初一-高三年级 · 个性定制",
          "初二-高三年级 · 个性定制",
          "初三-高三年级 · 个性定制",
        ],
      },
      isPopupFormShow: false,
    };
  },
  mounted() {},
  methods: {
    changeSubject(index) {
      saTrack("selectSubject");
      this.subjectSelect = index;
    },
    changeGrade(index) {
      saTrack("selectGrade");
      this.gradeSelect = index;
    },
    popupFormShow() {
      this.origin = "卡片_立即咨询";
      saTrack("consultNow");
      this.isPopupFormShow = true;
    },
    popupFormClose(data) {
      this.isPopupFormShow = data;
    }
  },
};
</script>
<style scoped lang="scss">
.course-warp {
  width: 100%;
  min-width: 1200px;
  background: #fff;
  .course-menu-warp {
    box-shadow: 0px 0px 8px 0px rgba(165, 165, 165, 0.7);
    .course-menu {
      width: 1200px;
      height: 100px;
      margin: 0 auto;
      padding-bottom: 2px;
      .menu-line {
        width: 100%;
        height: 50px;
        box-sizing: border-box;
        font-size: 14px;
        font-family: FZLanTingHei-R-GBK;
        font-weight: 400;
        .menu-title {
          color: #9c9c9c;
          margin-right: 24px;
          height: 25px;
          display: block;
          float: left;
          line-height: 25px;
        }
        .subject-item {
          float: left;
          padding: 3px 3px 3px 4px;
          height: 20px;
          border-radius: 2px;
          text-align: center;
          font-size: 14px;
          font-family: FZLanTingHei-R-GBK;
          font-weight: 400;
          color: #333;
          margin-right: 18px;
        }
        .subject-item-select {
          float: left;
          padding: 3px 3px 3px 4px;
          height: 20px;
          background: #e61623;
          border-radius: 2px;
          text-align: center;
          font-size: 14px;
          font-family: FZLanTingHei-R-GBK;
          font-weight: 400;
          color: #ffffff;
          margin-right: 18px;
        }
        .grade-list {
          margin-right: 25px;
          float: left;
          line-height: 25px;
          .border {
            display: inline-block;
            width: 10px;
            border-right: 1px solid #979797;
            height: 16px;
            margin-top: 6px;
          }
          .grade-item {
            padding: 3px 4px 3px 5px;
            height: 20px;
            border-radius: 2px;
            text-align: center;
            font-size: 14px;
            font-family: FZLanTingHei-R-GBK;
            font-weight: 400;
            color: #333;
            margin-right: 16px;
            display: block;
            float: left;
            line-height: 20px;
          }
          .grade-item-select {
            padding: 3px 4px 3px 5px;
            height: 20px;
            background: #e61623;
            border-radius: 2px;
            text-align: center;
            font-size: 14px;
            font-family: FZLanTingHei-R-GBK;
            font-weight: 400;
            color: #ffffff;
            margin-right: 16px;
            display: block;
            float: left;
            line-height: 20px;
          }
        }
        .grade-list:last-child {
          .border{
            display: none;
          }
        }
      }
      .menu-line:hover {
        cursor: pointer;
      }
      .grade-line {
        padding-top: 24px;
      }
      .subject-line {
        padding-top: 12px;
      }
    }
  }
  .course-content {
    width: 1200px;
    height: 644px;
    margin: 0 auto;
    padding-top: 40px;
    box-sizing: border-box;
  }
  .course-item {
    position: relative;
    float: left;
    width: 386px;
    height: 244px;
    margin: 0px 10px 57px 0px;
    padding-top: 40px;
    box-sizing: border-box;
    box-shadow: 0px 2px 6px 0px rgba(165, 165, 165, 0.5);
    border-radius: 0 0 4px 4px;
    .item-course{ 
      display: none;
    }
    .item-title {
      line-height: 23px;   
      font-size: 18px;
      font-family: FZLanTingHeiS-DB-GB;
      font-weight: 400;
      color: #333333;
      padding-left: 29px;
      margin-bottom: 8px;
      span {
        display: inline-block;
        width: 28px;
        height: 23px;
        line-height: 23px;
        border: 1px solid #DF2727;
        font-size: 18px;
        font-family: FZLanTingHeiS-DB-GB;
        font-weight: 400;
        color: #D70F1C;
        text-align: center;
        box-sizing: border-box;
      }
    }
    .item-subtitle {
      padding-left: 30px;
      margin-bottom: 27px;
      font-size: 16px;
      font-family: FZLanTingHei-R-GBK;
      font-weight: 400;
      color: #333333;
      line-height: 16px;
    }
    .item-des {
      padding-left: 28px;
      font-size: 14px;
      font-family: FZLanTingHei-R-GBK;
      font-weight: 400;
      color: #666666;
      line-height: 14px;
      margin-bottom: 39px;
    }
    .item-bottom  {
      border-top: 1px #EEEEEE solid;
      width: 100%;
      height: 76px;
      .img-warp {
        width: 201px;
        height: 63px;
        margin: 6px 0 7px 21px;
        float: left;
        display: flex;
        justify-content: space-between;
        img {
          width: 63px;
          height: 63px;
          // padding: 0 4px 0 2px;
        }
      }
      .item-appoint {
        float: left;
        width: 94px;
        height: 34px;
        background: #D70F1C;
        border-radius: 17px;
        margin: 21px 30px 21px 39px;
        text-align: center;  
        font-size: 14px;
        font-family: FZLanTingHeiS-DB-GB;
        font-weight: 400;
        color: #FFFFFF;
        line-height: 34px;
      }
    }
  }
  .course-item:first-child .item-course{
    background: url("~_img/coursecardimg/typebg.png") no-repeat;
    width: 80px;
    height: 23px;
    position: absolute;
    top: 0;
    font-size: 16px;
    font-weight: 400;
    color: #FFFFFF;
    line-height: 23px;
    padding-left: 12px;
    box-sizing: border-box;
    display: block;
  }
  .course-item:nth-child(2) .item-course {
    background: url("~_img/coursecardimg/typebg.png") no-repeat;
    width: 80px;
    height: 23px;
    position: absolute;
    top: 0;
    font-size: 16px;
    font-weight: 400;
    color: #FFFFFF;
    line-height: 23px;
    padding-left: 12px;
    box-sizing: border-box;
    display: block;
  }
  .course-item:hover {
    border-top: 1px solid #CFA972;
    box-shadow: 1px 6px 21px 0px rgba(165, 165, 165, 0.5);
    position: relative;
    top: -4px;
    cursor: pointer;
    .item-appoint {
      float: left;
      width: 115px;
      height: 42px;
      line-height: 42px;
      border-radius: 21px;
      margin: 17px 31px 17px 18px;
      text-align: center;  
      font-size: 17px;
    }
  }
}
</style>
